import React, { memo, useState } from 'react';
import Div from '@/shared/Div';
import Button from '@/shared/Button';
import Heading from '@/shared/Heading';
import ChevronDownIcon from '@/components/Icons/ChevronDownIcon';
import ChevronUpIcon from '@/components/Icons/ChevronUpIcon';
import classNames from 'classnames';

export interface AccordionProps {
  title?: string;
  list: any;
  renderTitle: Function;
  renderContent: Function;
  desktopScreen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  list,
  renderTitle,
  renderContent,
  desktopScreen = false,
}) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderChevronIcon = (index: number) => {
    if (desktopScreen) return null;
    else if (index === activeIndex) return <ChevronUpIcon />;
    else return <ChevronDownIcon />;
  };

  return (
    <Div>
      {title && (
        <Heading level={2} className="text-h-3 md:text-hd-2 border-b border-cti-on-secondary pb-s4">
          {title}
        </Heading>
      )}
      {list?.map((item: any, index: number) => (
        <Div
          key={index}
          className={classNames('cursor-pointer', {
            'border-b border-cti-on-secondary': !desktopScreen,
          })}
        >
          <Button
            className="w-full flex !items-start justify-between text-hd-5 md:text-hd-4 py-s5 !text-left"
            theme="none"
            dataTestId={`accordion-button-${index + 1}`}
            onClick={() => toggleAccordion(index)}
          >
            {renderTitle(item)}
            {renderChevronIcon(index)}
          </Button>
          {(activeIndex === index || desktopScreen) && (
            <Div className="pb-s5 text-body-base font-primary">{renderContent(item)}</Div>
          )}
        </Div>
      ))}
    </Div>
  );
};

export default memo(Accordion);
